import apiClient from './apiClient';

class RegisterClient {
    // 登記商城
    registerShop = (email) => apiClient.post('/register/shop', { email });

    // 登記論壇
    registerForum = (email) => apiClient.post('/register/chat', { email });
}

const registerClient = new RegisterClient();

export default registerClient;
